<template>
  <v-content class="pt-0 mt-0">
  <v-container fluid>
    <pr-loading v-model="loading" />
    <v-toolbar flat color="white" class="elevation-1">
      <v-toolbar-title>{{ $t('my contacts screen') }}</v-toolbar-title>
      <v-divider
        class="mx-2"
        inset
        vertical
      ></v-divider>
      <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="search"
          :label="$t('Search')"
          single-line
          hide-details
        ></v-text-field>
      <v-tooltip bottom>
        <v-btn slot="activator" color="primary" dark class="mb-2" @click="newItem" v-shortkey.once="['ctrl', 'alt', 'n']" @shortkey="newItem">{{ $t('New contact') }}</v-btn>
        {{ $t('Add new contact') }}
      </v-tooltip>
      <v-menu
        :close-on-content-click="false"
        :nudge-width="200"
        offset-x
      >
        <v-btn icon slot="activator">
          <v-icon class="text--secondary">settings</v-icon>
        </v-btn>

        <v-card>
          <v-list>
            <v-list-tile>
              <v-list-tile-content>
                <v-list-tile-title>{{ $t('Table settings') }}</v-list-tile-title>
                <v-list-tile-sub-title>{{ $t('Select visible columns') }}</v-list-tile-sub-title>
              </v-list-tile-content>
            </v-list-tile>
          </v-list>

          <v-divider></v-divider>

          <v-list>
            <v-list-tile v-for="(header,key) in headers" :key="key" v-if="header.value != 'actions'">
              <v-list-tile-action>
                <v-switch v-model="header.show" color="purple" :disabled="columnHideCheck(header)" @change="storeFilter"></v-switch>
              </v-list-tile-action>
              <v-list-tile-title>{{ header.text }}</v-list-tile-title>
            </v-list-tile>
          </v-list>
        </v-card>
      </v-menu>
    </v-toolbar>

    <v-layout row wrap>
      <v-flex xs12>

      <v-data-table
        :headers="headers"
        :items="data"
        :pagination.sync="pagination"
        :total-items="totalData"
        :loading="loading"
        :rows-per-page-items="[5, 10, 25]"
        :rows-per-page-text="$t('Rows per page')"
        class="elevation-1"
      >
      <template slot="headers" slot-scope="props">
        <tr>
          <th
            v-for="header in props.headers"
            :key="header.text"
            v-if="header.show"
            :class="['column sortable', pagination.descending ? 'desc' : 'asc', header.value === pagination.sortBy ? 'active' : '']"
            @click="changeSort(header.value)"
          >
            <v-icon small>arrow_upward</v-icon>
            <v-tooltip bottom>
              <span slot="activator">
                {{ header.text }}
              </span>
              <span>
                {{ header.text }}
              </span>
            </v-tooltip>
          </th>
        </tr>
      </template>
      <template v-slot:items="props">
        <td v-for="(header,idx) in headers" :key="idx" v-if="header.show && header.value !== 'actions'">{{ getObjectValue(props.item, idx) }}</td>
        <td class="justify-center layout px-0">
          <v-icon
            small
            class="mr-2"
            @click="editItem(props.item)"
          >
            edit
          </v-icon>
          <v-icon
            small
            @click="deleteItem(props.item)"
          >
            delete
          </v-icon>
        </td>
      </template>
    </v-data-table>
    <div class="text-xs-center pt-2">
      <v-pagination v-model="pagination.page" :length="pages" circle total-visible="7"></v-pagination>
    </div>
     </v-flex>
   </v-layout>
 </v-container>
 </v-content>
</template>

<script>
import _object from "lodash/object";
import { debounce } from "lodash";
import { contacts } from "../resources";
import { mapGetters, mapActions } from "vuex";
import { addressString } from "../components/util";
import PrLoading from "@/components/Loading";

export default {
 components: {
    PrLoading
  },
  data () {
    return {
        totalData: 0,
        data: [],
        search : '',
        loading: false,
        pagination: {},
        selected : [],
        headers: [
          {
            text: this.$t('PartnerName'),
            align: 'left',
            sortable: true,
            value: 'partner.name',
            show : true
          },
          { text: this.$t('Address'), value: 'addressDisplay', align: 'left', sortable: true, show : true },
          { text: this.$t('ContactName'), value: 'name', align: 'left', sortable: false, show : true },
          { text: this.$t('Phone'),   value: 'phone', align: 'left', sortable: false, show : true },
          { text: this.$t('Actions'), value: 'actions', align: 'center', sortable: false, show : true }
        ]
    }
  },
  computed: {
    ...mapGetters(['contactsFilter']),
    pages () {
      if (this.pagination.rowsPerPage == null ||
        this.totalData == null
      ) return 0;

      return Math.ceil(this.totalData / this.pagination.rowsPerPage);
    }
  },

  watch: {
      pagination: {
        handler () {
          this.listData();
        },
        deep: true
      },
      search : {
        handler() {
          this.listDataDebounced();
        }
      }
  },

  created () {
    this.listDataDebounced = debounce(this.listData, 1000);
  },

  mounted () {
    let myContactFilter = null;
    try {
      myContactFilter = JSON.parse(this.contactsFilter);
    } catch(e) {
      console.log("Filter cannot be parsed");
      myContactFilter = null;
    }

    if (myContactFilter) {
      this.search = myContactFilter.search;
      if (myContactFilter.pagination)
        this.pagination = myContactFilter.pagination;
      for (let i = 0; i < myContactFilter.shown.length; i++) {
        this.headers[i].show = myContactFilter.shown[i];
      }
    }

    this.getDataFromApi().then(data => {
        this.data = data.items;
        this.totalData = data.total;
      }, () => {
        console.log("mounting loading rejected");
      });
  },

  methods: {
    ...mapActions(["updateMyContactFilter"]),

    getObjectValue(obj, idx) {
      return _object.get(obj, this.headers[idx].value);
    },

    listData() {
      this.storeFilter();
      this.getDataFromApi().then(data => {
          this.data = data.items;
          this.totalData = data.total;
        }, () => {
          console.log('loading rejected');
        });
    },

    getDataFromApi () {
      if (this.loading)
        return new Promise((resolve, reject) => {
          reject();
        });

      this.loading = true;
      return new Promise((resolve, reject) => {
        const { sortBy, descending, page, rowsPerPage } = this.pagination;

        let offset = (page>=1 && rowsPerPage>=1) ? (page - 1) * rowsPerPage : 0;
        let limit  = (rowsPerPage>=1) ? rowsPerPage : -1;
        let query  = this.search;
        let sort   = (sortBy) ? (descending ? "-" : "") + sortBy : "";
        let t = {
          block : this.$t('block'),
          entrance : this.$t("entrance"),
          floor : this.$t("floor"),
          apartment : this.$t("apartment")
        };

        contacts.list({ limit, offset, query, sort }).then(response => {
          let items = response.body.result.map(el => {
            let a = addressString(el.address, t);
            el.settlementDisplay = a.settlement;
            el.addressDisplay = a.address;
            return el;
          });
          const total = response.body.length;
          resolve({ items, total });
        }).catch(response => {
          console.log("Error " + response.status);
          reject({ "status" : response.status, "text" : response.statusText });
        }).finally(() => {
          this.loading = false;
        });
      });
    },

    toggleAll () {
      if (this.selected.length)
        this.selected = [];
      else
        this.selected = this.data.slice();
    },

    changeSort(column) {
      if (column === "addressDisplay") {
        column = "address.settlement.name";
      }
      console.log("change sort of item #" + column);
      if (this.pagination.sortBy === column) {
        if (this.pagination.descending)
          this.pagination.sortBy = null;
        else
          this.pagination.descending = true;
      } else {
        this.pagination.sortBy = column;
        this.pagination.descending = false;
      }
    },

    newItem() {
      this.editItem({ id: 0 });
    },

    editItem (item) {
      this.$router.push({ name: "contact", params: { id: item.id }});
    },

    addString(c, text) {
      if (!text) return c;
      if (!!c && c.length > 0)
        c = c + ", ";
      return c + text;
    },

    deleteItem (item) {
      let//
      contact = !!item.partner && !!item.partner.name ? item.partner.name : "";
      contact = this.addString(contact, item.name);
      contact = this.addString(contact, item.phone);

      let msg = this.$t('Are you sure you want to delete the contact?', { name : contact });
      let title = this.$t('Confirm');
      let btnOk = this.$t('Ok');
      let btnCancel = this.$t('Cancel');

      this.$confirm(msg, { title, btnOk, btnCancel }).then((res) => {
        if (!res)
          return;

        contacts.delete({ id: item.id }).then((r) => {
            let idx = this.data.indexOf(item);
            if (idx >= 0)
              this.data.splice( idx, 1 );

            // force reload, TODO: is there another way?
            if (typeof this.pagination.descending === 'boolean')
              this.pagination.descending = !this.pagination.descending;
            else
              this.pagination.descending = true;

          }, (e)=>{
            console.log("Delete error");
          });
      });
    },

    columnHideCheck(header) {
      if (!header.show)
        return false;

      let v = 0;
      for (let i = 0; i < this.headers.length; i++)
        if (this.headers[i].value != 'actions' && this.headers[i].show)
          v++;

      return (v<2);
    },

    storeFilter() {
      let a = new Array();
      for (let i = 0; i < this.headers.length; i++)
        if (this.headers[i].value !== 'actions')
          a.push(this.headers[i].show);

      let s = {
        search : this.search,
        pagination : this.pagination,
        shown : a
      };
      this.updateMyContactFilter(JSON.stringify(s));
    }
  }
}
</script>

<style scoped>
</style>